<mat-tab-group color="primary" selectedIndex="{{ selectedIndex }}" (selectedIndexChange)="updateSelectedIndex($event)" data-cy="tab-custom-fields" class="custom-fields-container">
    <mat-tab label="Custom Dimensions">
        <app-custom-dimension-list></app-custom-dimension-list>
    </mat-tab>
    <mat-tab label="Custom Metrics">
        <app-custom-metric-list></app-custom-metric-list>
    </mat-tab>
</mat-tab-group>
